import { all } from "redux-saga/effects"
import { watchGetProviderAsync } from "./sagas/getprovider";
import { watchResetPasswordAsync } from "./sagas/resetpassword";
import { watchLoginAsync } from "./sagas/clientSideLogin";
import { watchLegacyLoginAsync } from "./sagas/legacyLogin";
import { watchLoginSuccessAsync } from "./sagas/createsession";
import { watchValidatePasswordAsync } from "./sagas/validatePassword";
import { watchAuthResponse } from "./sagas/handleAuthResponse";
import { watchMfaOtpCodeAsync } from "./sagas/verifyOtpCode";
import { watchMfaTotpCodeAsync } from "./sagas/verifyTotpCode";
import { watchChangePasswordAsync } from "./sagas/changepassword";
import { watchMfaChoiceAnswer } from "./sagas/chooseMfaType";
import { watchChangeEmail } from "./sagas/changeEmail";
import { handleErrorWatcher } from "./sagas/handleError";
import { watchMfaSkipAsync } from "./sagas/sendMfaSkip";
import { watchMfaEmailInit } from "./sagas/initEmailMfa";


export default function* rootSaga() {
    yield all([
        watchGetProviderAsync(),
        watchLoginAsync(),
        watchLegacyLoginAsync(),
        watchLoginSuccessAsync(),
        watchResetPasswordAsync(),
        watchValidatePasswordAsync(),
        watchAuthResponse(),
        watchMfaChoiceAnswer(),
        watchMfaOtpCodeAsync(),
        watchMfaTotpCodeAsync(),
        watchMfaSkipAsync(),
        watchMfaEmailInit(),
        watchChangePasswordAsync(),
        watchChangeEmail(),
        handleErrorWatcher(),
    ])
}
